'use client';

import { Button, SparkyTextWrapper } from '@petsmart-ui/sparky';
import { useState } from 'react';

import type { TruncateWithShowButtonProps } from './types';

export function TruncateWithShowButton({
    children,
    truncateLine = 3,
    buttonVariant = 'link',
    buttonWordings = {
        showMore: 'Show more',
        showLess: 'Show less',
    },
    handleClick,
    ...props
}: Readonly<TruncateWithShowButtonProps>) {
    const [showMore, setShowMore] = useState(false);

    const handleShowMore = () => {
        setShowMore(!showMore);
        if (!showMore) {
            handleClick?.();
        }
    };

    return (
        <>
            {showMore ? (
                children
            ) : (
                <SparkyTextWrapper
                    truncateOn={truncateLine}
                    data-testid="truncate-wrapper"
                >
                    {children}
                </SparkyTextWrapper>
            )}

            <Button
                data-testid="truncate-button"
                onClick={handleShowMore}
                text={
                    showMore ? buttonWordings.showLess : buttonWordings.showMore
                }
                variant={buttonVariant}
                {...props}
            />
        </>
    );
}
